import 'src/global.css';

import ReactGA from 'react-ga4';
import Clarity from '@microsoft/clarity';
// eslint-disable-next-line import/no-extraneous-dependencies
import { SnackbarProvider } from 'notistack';

import { Router } from 'src/routes/sections';

import { useScrollToTop } from 'src/hooks/use-scroll-to-top';

import { ThemeProvider } from 'src/theme/theme-provider';

if (process.env.NODE_ENV === "production") {
  console.log = () => {};
  ReactGA.initialize("G-18M9JPRDX3");
  Clarity.init('tw9h41q0vk');
}

export default function App() {
  useScrollToTop();

  return (
    <SnackbarProvider>
    <ThemeProvider>
      <Router />
    </ThemeProvider>
    </SnackbarProvider>
  );
}
